// The cookie-consent record: what is stored, and what counts as a valid one.
// No imports on purpose. public/index.html (script#consent-gate) holds an ES5
// twin of parseConsentRecord; consentRecord.test.js runs both over one table
// of inputs and asserts they agree. Change one, change the other.

export const CONSENT_KEY = 'ivori_cookie_consent';
// Bump when a provider, purpose or category is added or changed (not for a copy fix).
export const CONSENT_VERSION = 1;
// About 6 months. The ICO sets no period; CNIL recommends 6 months.
export const MAX_AGE_MS = 183 * 86400000;
// Tolerance for a device clock that is a little ahead.
export const FUTURE_SKEW_MS = 86400000;
export const PURPOSES = ['analytics', 'recording', 'advertising'];

const RECORD_KEYS = ['v', 'ts', ...PURPOSES];

/**
 * Parses a stored record. Returns {analytics, recording, advertising} for a
 * valid record, and null (no choice) for anything else: missing, unparseable,
 * not a plain object, wrong key set, old version, expired, future timestamp,
 * or a flag that is not a boolean.
 */
export function parseConsentRecord(raw, now) {
  if (typeof raw !== 'string') return null;
  let o;
  try {
    o = JSON.parse(raw);
  } catch (_) {
    return null;
  }
  if (!o || typeof o !== 'object' || Array.isArray(o)) return null;
  const keys = Object.keys(o);
  if (keys.length !== RECORD_KEYS.length) return null;
  if (!RECORD_KEYS.every((k) => Object.prototype.hasOwnProperty.call(o, k))) return null;
  if (o.v !== CONSENT_VERSION) return null;
  if (typeof o.ts !== 'number' || !Number.isFinite(o.ts)) return null;
  if (o.ts < now - MAX_AGE_MS || o.ts > now + FUTURE_SKEW_MS) return null;
  if (!PURPOSES.every((p) => typeof o[p] === 'boolean')) return null;
  return { analytics: o.analytics, recording: o.recording, advertising: o.advertising };
}

/** The record to store for a choice. Anything not exactly true is false. */
export function buildConsentRecord(choice, now) {
  return {
    v: CONSENT_VERSION,
    ts: now,
    analytics: !!choice && choice.analytics === true,
    recording: !!choice && choice.recording === true,
    advertising: !!choice && choice.advertising === true,
  };
}
